import * as moment from 'moment';

export default class Utils {
  public static createGuid(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = Math.random() * 16 | 0; const v = c === 'x' ? r : (r & 0x3 | 0x8);

      return v.toString(16);
    });
  }

  public static randomString(keyLength: number=16): string {
    let i; let key = ''; const characters = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';

    const charactersLength = characters.length;

    for (i = 0; i < keyLength; i++) {
      key += characters[Math.floor((Math.random() * charactersLength) + 1)];
    }

    return key;
  }

  public static toSorted<T>(lookUpItems: T[], fn): T[] {
    return lookUpItems.sort(fn);
  }
}

export const  isUUID = (uuid: string) => {
  uuid = '' + uuid;
  const regex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

  return regex.exec(uuid) !== null;
};

export const localDateFormat = (separator='/')=>{
  const strDate = moment.localeData().longDateFormat('L');

  const format = strDate
    .replace(/\//g,separator);

  return format;
};

export const sanitizeString = (input: string): string => input
  .toLowerCase()
  .replace(/\s+/g, '')
  .replace(/[^a-z0-9]/g, '');

// to resolve nested properties like UOM.uomName
export const getPropertyValueByPath = (object: object, path: string, defaultValue: any = ''): any => path.split('.')
  .filter(p => p)
  .reduce((o, p) => o ? o[p] : defaultValue, object);

// for string data type columns that can use both string and numeric values
//https://medium.com/@sudha.malpeddi/alphanumeric-strings-sorting-with-javascript-375f743e5c94
export const compareStrings = (value1: any, value2: any): number => {
  return value1.localeCompare(value2, 'en', {
    numeric: true,
    sensitivity: 'base'
  });
}
